import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Swords } from "lucide-react";

const STORAGE_KEY = "cta_welcome_seen";

// One-time welcome message shown after sign-in. Dismiss-once-forever, tracked per-user in
// localStorage (no backend field needed for v1).
export function WelcomeIntroModal({ userId }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!userId) return;
    const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!seen.includes(userId)) setOpen(true);
  }, [userId]);

  const dismiss = () => {
    const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!seen.includes(userId)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, userId]));
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && dismiss()}>
      <DialogContent className="max-w-md" data-testid="welcome-intro-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#f1e0c5] flex items-center gap-2">
            <Swords className="w-5 h-5 text-[#D90429]" /> You Heard Our Call
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#f1e0c5]/70 leading-relaxed">
          We are honored you chose to fight alongside us! If you need assistance, look for the
          <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] mx-1 text-[10px] align-middle">i</span>
          icons next to tricky features — tap one anytime for a quick how-to.
        </p>
        <Button data-testid="welcome-intro-dismiss-button" onClick={dismiss} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-xs">
          To Battle
        </Button>
      </DialogContent>
    </Dialog>
  );
}
